// extracted by mini-css-extract-plugin
export var banner = "_s6-0";
export var settingRow = "_s6-2";
export var titleIcon = "_s6-1";